export const EXPERIMENT_USER_KEY = 'exps_guest_id';

export const PREFIX_BRANCH = 'exps-';

export const DEFAULT_BRANCH = 'original';
